// extracted by mini-css-extract-plugin
export default {"name_film":"NameFilm_name_film__dkV9I","category":"NameFilm_category__suPIS","film":"NameFilm_film__1SqC4"};